import React from 'react';
import Link from '../../../01-atoms/links/Link.component';
import Logo from '../../../01-atoms/images/Logo/Logo.component';
import Breadcrumbs from '../../../02-molecules/menus/Breadcrumbs/Breadcrumbs.component';
import MainMenu from '../../../02-molecules/menus/MainMenu/MainMenu.component';
import { menuItemPropType } from '../../../02-molecules/menus/MenuItem.component';
import bem from '../../../_utils/bem';

var SiteHeader = function SiteHeader(_ref) {
  var breadcrumbs = _ref.breadcrumbs,
      menu = _ref.menu;
  var block = 'header';
  return /*#__PURE__*/React.createElement("header", {
    className: bem(block)
  }, /*#__PURE__*/React.createElement("div", {
    className: bem(block, 'primary')
  }, /*#__PURE__*/React.createElement("div", {
    className: bem(block, 'branding')
  }, /*#__PURE__*/React.createElement(Link, {
    modifiers: ['logo-link'],
    url: "/"
  }, /*#__PURE__*/React.createElement(Logo, {
    block: "logo",
    element: "image"
  }))), /*#__PURE__*/React.createElement("div", {
    className: bem(block, 'menu')
  }, /*#__PURE__*/React.createElement(MainMenu, {
    items: menu
  }))), /*#__PURE__*/React.createElement("div", {
    className: bem(block, 'secondary')
  }, /*#__PURE__*/React.createElement(Breadcrumbs, {
    items: breadcrumbs
  })));
};

export default SiteHeader;